import { IonContent, IonCard, IonCardContent, IonButton, IonIcon, IonToast, IonTabBar, IonTabButton, IonLabel, IonBadge, IonSegment, IonSegmentButton, IonSegmentView, IonSegmentContent } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { calendar, card, copyOutline, heart, logoBitcoin, musicalNote } from 'ionicons/icons';

import { get } from '@/controllers/preferences'

const Billing: React.FC = () => {
  const [userId, setUserId] = useState("");
  const [showEmailToast, setShowEmailToast] = useState(false);
  const [showUserIdToast, setShowUserIdToast] = useState(false);

  const copyToClipboard = (text: string, type: 'email' | 'userId') => {
    navigator.clipboard.writeText(text).then(() => {
      if (type === 'email') {
        setShowEmailToast(true);
      } else {
        setShowUserIdToast(true);
      }
    });
  };

  useEffect(() => {
    const later = async () => {
      setUserId(await get("user_id"));
    }

    later()
  }, [])

  return (
    <IonContent className="ion-padding bg-orange-50 dark:bg-orange-900/20">
      <div className="max-w-2xl mx-auto py-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-orange-800 dark:text-orange-200">Do you want superpowers?</h1>
          <p className="text-orange-600 dark:text-orange-300 mt-2">
            Support Convolution and help us improve the platform for everyone
          </p>
        </div>

        <IonCard className="shadow-sm rounded-lg overflow-hidden border border-orange-200 dark:border-orange-700 bg-white dark:bg-gray-800">

          <IonSegment>
            <IonSegmentButton value="e-transfer" contentId="e-transfer">
              <IonIcon icon={card} />
              <IonLabel>e-Transfer</IonLabel>
              <IonBadge color="danger"></IonBadge>
            </IonSegmentButton>
            <IonSegmentButton value="crypto" contentId="crypto">
              <IonIcon icon={logoBitcoin} />
              <IonLabel>Crypto</IonLabel>
            </IonSegmentButton>
          </IonSegment>
          <IonCardContent className="p-6">
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-orange-800 dark:text-orange-200 mb-3">
                Support Convolution
              </h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Your contribution helps us continue developing innovative learning tools. 
              </p>
              <IonSegmentView>
                <IonSegmentContent id="e-transfer">                
                  <p className='pt-2'>
                    Send your support via Interac e-Transfer to:
                  </p>
                  <div className="bg-orange-100 dark:bg-orange-800/50 rounded-lg p-3 flex items-center justify-between">
                    <p className="font-mono text-orange-700 dark:text-orange-300 break-all text-center">
                      pay@soclearn.org
                    </p>
                    <IonButton fill="clear" size="small" onClick={() => copyToClipboard('pay@soclearn.org', 'email')}>
                      <IonIcon icon={copyOutline} />
                    </IonButton>
                  </div>
                </IonSegmentContent>
                <IonSegmentContent id="crypto">
                  <p className='pt-2'>
                    Send your support via BTC to:
                  </p>
                  <div className="bg-orange-100 dark:bg-orange-800/50 rounded-lg p-3 flex items-center justify-between">
                    <p className="font-mono text-orange-700 dark:text-orange-300 break-all text-center">
                      bc1phmxlxpzeskm9xh33uk2w55tdamd6t0uxtevsp5us358dezcswmcsl4zqu2
                    </p>
                    <IonButton fill="clear" size="small" onClick={() => copyToClipboard('bc1phmxlxpzeskm9xh33uk2w55tdamd6t0uxtevsp5us358dezcswmcsl4zqu2', 'email')}>
                      <IonIcon icon={copyOutline} />
                    </IonButton>
                  </div>
                  <p className='pt-2'>
                    Send your support via ETH to:
                  </p>
                  <div className="bg-orange-100 dark:bg-orange-800/50 rounded-lg p-3 flex items-center justify-between">
                    <p className="font-mono text-orange-700 dark:text-orange-300 break-all text-center">
                      0xd93f017fb62D878f52A9d89B1b54b7b51dac7054
                    </p>
                    <IonButton fill="clear" size="small" onClick={() => copyToClipboard('0xd93f017fb62D878f52A9d89B1b54b7b51dac7054', 'email')}>
                      <IonIcon icon={copyOutline} />
                    </IonButton>
                  </div>
                  <p className='pt-2'>
                    Send your support via XMR to:
                  </p>
                  <div className="bg-orange-100 dark:bg-orange-800/50 rounded-lg p-3 flex items-center justify-between">
                    <p className="font-mono text-orange-700 dark:text-orange-300 break-all text-center">
                      monero:4BAqGanvTqKE3bQUVNFB4vEkS4TxrSvbqMeZndGyw1XA142723dyRGq1NGdwT3XGBS3baU2jBuYFLEckAzKgf4cbDbECNnV?tx_description={userId}
                    </p>
                    <IonButton fill="clear" size="small" onClick={() => copyToClipboard(`monero:4BAqGanvTqKE3bQUVNFB4vEkS4TxrSvbqMeZndGyw1XA142723dyRGq1NGdwT3XGBS3baU2jBuYFLEckAzKgf4cbDbECNnV?tx_description=${userId}`, 'email')}>
                      <IonIcon icon={copyOutline} />
                    </IonButton>
                  </div>
                </IonSegmentContent> 
              </IonSegmentView>
            </div>

            <div className="mb-6">
              <h2 className="text-xl font-semibold text-orange-800 dark:text-orange-200 mb-3">
                Include Your User ID
              </h2>
              <p className="text-gray-700 dark:text-gray-300 mb-3">
                Please include your user ID in the payment message:
              </p>
              <div className="bg-orange-100 dark:bg-orange-800/50 rounded-lg p-3 flex items-center justify-between">
                <p className="font-mono text-orange-700 dark:text-orange-300 break-all">
                  {userId || "Loading your user ID..."}
                </p>
                <IonButton fill="clear" size="small" onClick={() => copyToClipboard(userId, 'userId')}>
                  <IonIcon icon={copyOutline} />
                </IonButton>
              </div>
            </div>

            <div className="mb-2">
              <h2 className="text-xl font-semibold text-orange-800 dark:text-orange-200 mb-3">
                Share Your Ideas/Requests
              </h2>
              <p className="text-gray-700 dark:text-gray-300">
                When you send your contribution, let us know what features or improvements you'd like to see.
                We value your feedback and use it to guide our development!
              </p>
            </div>

            <div className="text-center mt-8">
              <p className="text-orange-600 dark:text-orange-400">
                Thank you for supporting Convolution! Any amount helps us continue our mission.
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-4">
                Questions? Contact us at support@soclearn.org
              </p>
            </div>
          </IonCardContent>
        </IonCard>
        
        <IonToast
          isOpen={showEmailToast}
          onDidDismiss={() => setShowEmailToast(false)}
          message="Address copied to clipboard!"
          duration={2000}
        />
        
        <IonToast
          isOpen={showUserIdToast}
          onDidDismiss={() => setShowUserIdToast(false)}
          message="User ID copied to clipboard!"
          duration={2000}
        />
      </div>
    </IonContent>
  );
};

export default Billing;
